import cx from 'classnames';
import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';
import s from './styles.scss';
import { Filter, Nav } from './components';
import {
  Button,
  CopyLink,
  utils as u,
  enums as e,
  Icon,
  Loader,
} from 'edrolo-ui';
import urlResolver from 'edrolo/utils/URLResolver';
import { Container } from 'edrolo-style-guide';
import { useRef } from 'react';
import {
  useCreateAndNavigateToTask,
  useCourses,
} from 'edrolo/domains/coursePortal/hooks';
import { WaffleFlag } from 'edrolo/utils/Waffle';
import { useAnalytics } from 'edrolo/analytics';
import { EXAM_ANALYTICS_CONSTANTS } from '../../../../constants';

export const SubHeader = ({
  navItems,
  analyticsPayload,
  searchParams,
  isTeacher,
  classId,
  exam,
  filterToggle,
}) => {
  const offsetRef = useRef(null);

  const { createAndNavigateToTask, isLoading } = useCreateAndNavigateToTask();

  const courseId = exam.get('course');
  const topicId = exam.getIn(['topic', 'id']);
  const examId = exam.get('id');

  const { data: taskEnabledCourseProducts } = useCourses(['task_setting']);

  const { track } = useAnalytics({});

  const tasksEnabled =
    taskEnabledCourseProducts?.some((product) => product.id === courseId) ||
    false;

  return (
    <div
      className={s.subHeader}
      ref={offsetRef}
      data-appcues="sub-header"
      data-test="sub-header"
    >
      <Container wide>
        <div className={s.titleBlock}>
          <h3 className={s.title}>Questions</h3>

          <div className={cx(u.flex, u.alignCenter, u.gap2)}>
            <Filter
              searchParams={searchParams}
              filterToggle={filterToggle}
              courseId={exam.get('course')}
              analyticsPayload={analyticsPayload}
            />

            {isTeacher && (
              <>
                <CopyLink
                  hideText
                  shortLinkProps={{
                    id: exam.get('id'),
                    appLabel: 'exams',
                    model: 'exam',
                    queryString: `?${searchParams.toString()}`,
                  }}
                  buttonProps={{
                    size: e.Size.SMALL,
                    variant: e.Variant.OUTLINE,
                  }}
                />

                <Button.Link
                  size={e.Size.SMALL}
                  to={urlResolver.reverse('question-set-grid', {
                    classId,
                    examId: exam.get('id'),
                  })}
                >
                  View Responses
                </Button.Link>

                {tasksEnabled && (
                  <WaffleFlag name="task_setting">
                    <Button
                      color={e.ColorTheme.SECONDARY}
                      size={e.Size.SMALL}
                      onClick={() => {
                        createAndNavigateToTask({ courseId, topicId, examId });
                        track('Create Task - Started', {
                          origin: EXAM_ANALYTICS_CONSTANTS.ORIGIN.QUESTION_SET,
                        });
                      }}
                    >
                      {isLoading ? (
                        <Loader.Spinner className={u.mr2} />
                      ) : (
                        <Icon name={e.Icons.TASK} className={u.mr2} />
                      )}
                      Create task
                    </Button>
                  </WaffleFlag>
                )}
              </>
            )}
          </div>
        </div>

        <Nav
          navItems={navItems}
          analyticsPayload={analyticsPayload}
          offsetRef={offsetRef}
        />
      </Container>
    </div>
  );
};

SubHeader.propTypes = {
  analyticsPayload: PT.object.isRequired,
  navItems: IPT.list.isRequired,
  searchParams: PT.object.isRequired,
  isTeacher: PT.bool.isRequired,
  exam: IPT.map.isRequired,
  classId: PT.oneOfType([PT.string, PT.number]).isRequired,
  filterToggle: PT.shape({
    hasSpiciness: PT.bool.isRequired,
    hasWorkingPaths: PT.bool.isRequired,
  }).isRequired,
};
